import { render } from "./Benefits.vue?vue&type=template&id=62c1dd08&scoped=true"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"

import "./Benefits.vue?vue&type=style&index=0&id=62c1dd08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c1dd08"]])

export default __exports__